import DefaultLayout from '##/Default';
import Matrix from './Matrix';
import MatrixV2 from './MatrixV2';


const routes = [
    {
        path: '/properties/:property_id/reports/matrix',
        exact: true,
        layout: DefaultLayout,
        component: Matrix,
        auth: true,
        title: 'Property Matrix'
    },
    {
        path: '/properties/:property_id/reports/matrix-and-leasing',
        exact: true,
        layout: DefaultLayout,
        component: MatrixV2,
        auth: true,
        title: 'Matrix v2'
    }
];

export default routes;
